<template>
  <div class="map-container">
    <div id="localMap"></div>
  </div>
</template>

<script>

import initBingMap from '../plugins/initMap'

export default {
  props:{
    'inspectors':Array,//验货员
    "orderLon":String,//订单
    "orderLat":String,
    "keywords":String,//地址关键词
  },
  data () {
    return {
      lngNum: null, // 经度
      latNum: null, // 纬度
      map:null,
      infobox:'',
      searchManager:'',
    }
  },
  created: function () { 
    
    let _this = this;
    initBingMap.init()
    .then((Microsoft) => {
      console.log("加载成功...")
      setTimeout(function(){
        _this.initMap();
      },1000)
      
    })
    
  },
  methods: {
    //通过地址获取经纬度 建立图钉-----------------------------------------------------------
    Search() {
      let _this = this
      if (!this.searchManager) {
      //Create an instance of the search manager and perform the search.
        Microsoft.Maps.loadModule('Microsoft.Maps.Search', function () {
          _this.searchManager = new Microsoft.Maps.Search.SearchManager(_this.map);
          _this.Search()
        });
      } else {
      //Remove any previous results from the map.
        this.map.entities.clear();
        //Get the users query and geocode it.
        let query = this.keywords
        console.log("query",query)
        this.geocodeQuery(query);
      }
    },
     geocodeQuery(query) {
       let _this = this
        var searchRequest = {
          where: query,
          callback: function (r) {
            console.log(r)
            if (r && r.results && r.results.length > 0) {
              var pin, pins = [], locs = [];
              for (var i = 0; i < 1; i++) {
                //Create a pushpin for each result.
                pin = new Microsoft.Maps.Pushpin(r.results[i].location, {
                  color: 'red', // 纯色图钉
                });
                pins.push(pin);
                locs.push(r.results[i].location);
              }
              //Add the pins to the map
              _this.map.entities.push(pins);
              //Determine a bounding box to best view the results.
              var bounds;
              if (r.results.length == 1) {
                bounds = r.results[0].bestView;
              } else {
              //Use the locations from the results to calculate a bounding box.
                bounds = Microsoft.Maps.LocationRect.fromLocations(locs);
              }
              _this.map.setView({ bounds: bounds });
            }
          },
          errorCallback: function (e) {
          //If there is an error, alert the user about it.
            // alert("No results found.");
          }
        };
        //Make the geocode request.
        this.searchManager.geocode(searchRequest);
    },

    //标注用户 订单 验货员 图钉-------------------------------------------------------------
    setPin(){
      let _this = this
      //添加订单 图钉
       let centerOrder = {
        latitude:this.orderLat,
        longitude:this.orderLon
      }
      this.infobox = new Microsoft.Maps.Infobox(_this.map.getCenter(), {
          visible: false
      });

      this.infobox.setMap(this.map);
      //  创建订单图钉
      let pinOrder = new Microsoft.Maps.Pushpin(centerOrder, {
        title: '', // 图钉的标题
        subTitle: '', // 图钉主体文字
        text: '', // 图钉内的文字
        // demo_2
        color: 'red', // 纯色图钉
      });
      this.map.entities.push(pinOrder);

      //循环 添加验货员图钉
      this.inspectors.forEach(item => {
        // if(item.)
        let center = {
          latitude:item.users.lat,
          longitude:item.users.lon
        }
         var pin = new Microsoft.Maps.Pushpin(center,{
           color:'green'
         });

        //Store some metadata with the pushpin.
        pin.metadata = {
            title: item.users.nick,
            description: '电话' + item.users.phone,
            
        };

        //Add a click event handler to the pushpin.
        Microsoft.Maps.Events.addHandler(pin, 'click', this.pushpinClicked);

        //Add pushpin to the map.
        this.map.entities.push(pin);
      })   
    },
    pushpinClicked(e) {
      if (e.target.metadata) {
        this.infobox.setOptions({
            location: e.target.getLocation(),
            title: e.target.metadata.title,
            description: e.target.metadata.description,
            visible: true
        });
      }
    },
    initMap () {
      let _this = this;
      // var loc = new Microsoft.Maps.Location(_this.orderData.lat, _this.orderData.lon);// 纬度 经度
      this.map = new Microsoft.Maps.Map('#localMap', {
        credentials: 'AgzeobkGvmpdZTFuGa7_6gkaHH7CXHKsFiTQlBvi55x-QLZLh1rSjhd1Da9bfPhD',
        // center: new Microsoft.Maps.Location(_this.orderLat, _this.orderLon),
      });
      Microsoft.Maps.Events.addHandler(_this.map, 'click', _this.getClickLocation);
      if(this.keywords){
        this.Search()
      }
      
      if(this.orderLon){
        this.setPin()
      }
      
    },
    getClickLocation (e) {
      //若点击到地图的标记上，而非地图上
      let [_this, loc] = [this, null];
      if (e.targetType == 'pushpin') {
        loc = e.target.getLocation();
      }
      //若点击到地图上
      else {
        var point = new Microsoft.Maps.Point(e.pageX, e.pageY);
        loc = e.target.tryPixelToLocation(point, Microsoft.Maps.PixelReference.page);
      }
      console.log(loc.latitude+", "+loc.longitude);
      _this.lngNum = loc.longitude;
      _this.latNum = loc.latitude;
      let data = {
        lngNum: _this.lngNum,
        latNum: _this.latNum
      }

      this.$emit('getLocationNums',data);
    },
  }
}
</script>

<style scoped>
  .map-container {
    width: 100%;
    height: 100%;
    border: 1px solid #000;
  }
</style>